import { BASE_DATETIME } from '@/utvStore/components/recommend/lp/commons'

import moment from 'moment'
const now = new moment()
const diffFromBase = now.diff(BASE_DATETIME, 'years')

const baseInfo = {
  id: 3,
  name: '斗弥',
  kana: 'とうわ',
  roman: 'Touwa',
  mainMethod: '属性開抛',
  mainMethodKana: 'ぞくせいかいほう',
}

const additionalInfo = {
  description: `老舗クラブでのホスト経験を持つ異色の占い師。数奇な運命に引き寄せられ赴いた熊本で、占いカフェバーのオーナーになり、地元メディアの常連となる。ホスト時代に鍛えた人間観察力を土台にしたわかりやすい表現で、心のひだまで届く鑑定を行い、自分らしい生き方を探す老若男女に人気を博している。`,
  methods: '属性開抛、タロット',
  yearsOfAppraisal: `${diffFromBase + 3}年`,
  appraisalNum: '１万人以上',
  managementOffice: {
    name: 'Luck Out',
    url: '',
  },
}

const forProfilePage = {
  realNameBornPlaceAge: '非公表',
  basicFortune: `/recommend/${baseInfo.id}/basic/input`,
  profileImage: '/static/img/recommend/lp/touwa/profileImage1.png',
  directAppraisal: {
    message: '占い師本人による直接鑑定は、現在WEBサービスでの特典（抽選制）でのみの受付となっています。詳細は各サービスの情報をご覧ください'
  },
  digitalFortune: {
    name: '占いTV',
    url: '',
  },
  salonTypeCommunity: {
    name: 'BaseCamp（月額制／毎月抽選での有料鑑定あり）',
    url: '',
  }
}

const tellerList = {
  description: '本質を探る独自占術と禅タロットですべてを見透かす元ホスト占い師',
  thumbnail: '/static/img/recommend/lp/touwa/counselor_160x160.jpg',
}

export default {
  ...baseInfo,
  ...additionalInfo,
  profilePage: forProfilePage,
  tellerList,
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/recommend/lp/counselor/touwa/info/profile.js